/* eslint-disable consistent-return */

import { LabelWrapper } from '@gameday/react-components/components'
import ListItem from '@gameday/react-components/components/ListItem'
import cn from 'classnames'
import styled, { css } from 'styled-components'

import commonStyles from '../../../styles/common-styles.module.scss'
import styles from '../../styles.module.scss'

const StyledListItem = styled.div`
  .MuiListItem-root,
  .MuiButtonBase-root,
  .MuiListItem,
  .MuiListItem-button {
    .MuiRadio-colorPrimary.Mui-checked {
      color: var(--custom-primary-color) !important;
    }
    .MuiCheckbox-colorPrimary.Mui-checked {
      color: var(--custom-primary-color);
    }
  }

  ${props =>
    props.showDescription &&
    css`
      > div {
        height: 52px;
      }
    `}
`

const sortOptions = (options = []) => {
  const sorted = [...options]
  sorted.sort((a, b) => Number(a.order) - Number(b.order))
  return sorted
}

function PickList({
  onChange = () => {},
  onBlur = () => {},
  value,
  disabled,
  errorText,
  label,
  options,
  type,
  helpText,
  isMandatory,
  id,
  showDescription = false,
  isTeamQuestion,
  dataTestId,
  ...rest
}) {
  const sortedOptions = sortOptions(options)
  return (
    <div className={styles.standardContainer}>
      <LabelWrapper
        label={label}
        isRequired={isMandatory}
        errorText={errorText}
        isToolTip={helpText}
        toolTipText={helpText}
      >
        <StyledListItem
          className={cn(styles.pickListContainer, { [styles.scrollingPicks]: sortedOptions.length > 9 })}
          showDescription
        >
          {sortedOptions.map(ans => {
            let { description } = ans

            // biome-ignore lint/complexity/useOptionalChain: TODO
            const isChecked = type === 'Picklist' ? value === ans.value : !!(value || {})[ans.value]

            let isDisabled = !!disabled

            if (isTeamQuestion) {
              const { teamPrimaryContact, teamParticipantLimitExceeded = false } = ans

              description = teamPrimaryContact || description

              if (teamParticipantLimitExceeded) {
                isDisabled = true
                description = <span style={{ fontStyle: 'italic' }}>Maximum participants for this team reached.</span>
              }
            }

            return (
              <ListItem
                className={commonStyles.listItem}
                key={ans.value}
                type={type === 'Picklist' ? 'radio' : 'checkbox'}
                isChecked={isChecked}
                onSelected={() => {
                  if (type === 'Picklist') {
                    return onChange(ans.value)
                  }
                  if (type === 'multiPicklist') {
                    let newValues = { ...value }
                    if (!newValues[ans.value]) {
                      newValues[ans.value] = true
                      return onChange(newValues)
                    }
                    delete newValues[ans.value]
                    if (Object.keys(newValues).length < 1) {
                      newValues = undefined
                    }
                    onChange(newValues)
                  }
                }}
                disabled={isDisabled}
                id={`${id}-option-${ans.value}`}
                label={ans.label}
                description={description}
                dataTestId={dataTestId}
                {...rest}
              />
            )
          })}
        </StyledListItem>
        {sortedOptions.length > 9 ? <div className={styles.scrollMore}>Scroll for more</div> : null}
      </LabelWrapper>
    </div>
  )
}

export default PickList
